import { isObject } from './isObject';
import { IOrderDiscount } from '@domain/orders/types';

export const isOfferAReward = (offer: IOrderDiscount): boolean => {
  return isObject(offer) && 'spotOnRewardId' in offer;
};
